WiseMetering.Views.AddTenant = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/tenants/add',
    title: () => i18next.t('modal.title.tenants.new'),
    form_prefix: 'tenant',
    className: 'mbx-info text-left'
});
